'use client';

import { useContext } from 'react';

import { AppContext } from '../App';
import ProtectedRoute from '../components/ProtectedRoute';
import { KDSPermission } from '../libs';
import ComponentsCheck from '../views/ComponentsCheck';

export default function Page() {
  const { kitchen, date } = useContext(AppContext);
  return (
    <ProtectedRoute permission={KDSPermission.VIEW_COMPONENTS_CHECK}>
      <ComponentsCheck kitchen={kitchen} date={date} />
    </ProtectedRoute>
  );
}
